import classNames from "classnames"
import style from "components/Hero.module.scss"
import { motion } from "framer-motion"
import Img from "gatsby-image"
import { useStores } from "hooks/useStores"
import {
  childVariants,
  highlightVariants,
  imageVariants,
  rootVariants
} from "lib/constants"
import { formatMarkdown } from "lib/helpers"
import camelCase from "lodash/camelCase"
import startCase from "lodash/startCase"
import { observer } from "mobx-react"
import PropTypes from "prop-types"
import React from "react"
import { useInView } from "react-intersection-observer"

const Hero = ({
  heading,
  introduction,
  image,
  statementsPosition,
  highlightColor,
  highlightPosition
}) => {
  const { uiStore } = useStores()

  if (!image) return null

  const { ref, inView, entry } = useInView({
    triggerOnce: false,
    threshold: 0.5
  })

  const { width, height } = image.file.details.image

  const aspect = width > height ? "landscape" : "portrait"
  const imageType = uiStore.isSmallerThanDesktop ? "mobile" : "desktop"

  const fluid =
    imageType === "mobile"
      ? image.mobile
      : image[`${imageType}${startCase(aspect)}`]

  const className = classNames(
    style.root,
    style[`root___statements_${camelCase(statementsPosition)}`],
    style[`root___highlight_${camelCase(highlightPosition)}`],
    style[`root___aspect_${aspect}`],
    style[`root___highlightColor_${camelCase(highlightColor)}`]
  )

  return (
    <motion.div
      className={className}
      ref={ref}
      variants={rootVariants}
      initial="initial"
      animate={inView ? "animate" : "initial"}
      exit="exit"
    >
      <div className={style.content}>
        <motion.div className={style.media} variants={imageVariants}>
          <div className={style.image}>
            <div className={style.img}>
              {!!image && (
                <Img
                  placeholderStyle={{ visibility: "hidden" }}
                  fluid={fluid}
                />
              )}
            </div>
            <motion.div
              className={style.highlight}
              variants={highlightVariants}
            />
          </div>
        </motion.div>

        <motion.div className={style.text} variants={childVariants}>
          <h1 className={style.heading}>{heading}</h1>
          <div
            className={style.introduction}
            dangerouslySetInnerHTML={{ __html: formatMarkdown(introduction) }}
          />
        </motion.div>
      </div>
    </motion.div>
  )
}

Hero.propTypes = {
  heading: PropTypes.string.isRequired,
  introduction: PropTypes.string.isRequired,
  statementsPosition: PropTypes.string.isRequired,
  highlightPosition: PropTypes.string.isRequired
}

Hero.defaultProps = {}

export default observer(Hero)
